import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  FaHome,
  FaMapMarkedAlt,
  FaUsers,
  FaCalendarAlt,
  FaClipboardList,
  FaChartPie,
  FaComments,
  FaTools
} from 'react-icons/fa';

const TABS = [
  { key: 'overview', label: 'Overview', icon: FaHome, path: (id) => `/clubs/${id}` },
  { key: 'map', label: 'Map', icon: FaMapMarkedAlt, path: (id) => `/clubs/${id}/map` },
  { key: 'members', label: 'Members', icon: FaUsers, path: (id) => `/clubs/${id}?tab=members` },
  { key: 'calendar', label: 'Calendar', icon: FaCalendarAlt, path: (id) => `/clubs/${id}/calendar` },
  { key: 'rules', label: 'Rules', icon: FaClipboardList, path: (id) => `/clubs/${id}/rules` },
  { key: 'stats', label: 'Stats', icon: FaChartPie, path: (id) => `/clubs/${id}?tab=stats` },
  { key: 'board', label: 'Board', icon: FaComments, path: (id) => `/clubs/${id}/board` },
  { key: 'admin', label: 'Admin', icon: FaTools, path: (id) => `/clubs/${id}?tab=admin`, gated: true }
];

export function ClubTabsNav({ isPresident, activeKey: activeKeyProp, onSelect, boardUnreadCount = 0, joinGateActive = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { clubId } = useParams();

  const activeKey = activeKeyProp || (() => {
    const path = location.pathname;
    if (path.endsWith('/map')) return 'map';
    if (path.endsWith('/calendar')) return 'calendar';
    if (path.endsWith('/rules')) return 'rules';
    if (path.endsWith('/board') || path.includes('/board/')) return 'board';
    // Query-based tabs fallback handled by parent via activeKeyProp
    return 'overview';
  })();

  const handleSelect = (tab) => {
    const next = tab.path(clubId);
    if (next === location.pathname + location.search) return;
    if (onSelect) {
      onSelect(tab.key);
    } else {
      navigate(next);
    }
  };

  return (
    <div className="club-tabs" role="tablist" aria-label="Club sections">
      {TABS.filter((tab) => !tab.gated || isPresident).map((tab) => {
        const Icon = tab.icon;
        const isActive = activeKey === tab.key;
        const isDisabled = joinGateActive && tab.key !== 'rules';
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            aria-label={tab.label}
            aria-disabled={isDisabled}
            className={`club-tab${isActive ? ' is-active' : ''}${tab.key === 'admin' ? ' club-tab--admin' : ''}${isDisabled ? ' club-tab--disabled' : ''}`}
            onClick={() => {
              if (!isDisabled) handleSelect(tab);
            }}
            disabled={isDisabled}
          >
            <Icon aria-hidden />
            <span className="club-tab__label">{tab.label}</span>
            {tab.key === 'board' && boardUnreadCount > 0 ? (
              <span className="club-tab-unread-badge" aria-label={`${boardUnreadCount} unread board posts`}>
                {boardUnreadCount > 99 ? '99+' : boardUnreadCount}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}

export default ClubTabsNav;


